// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advance-layout > #toolbar {
  z-index: 16;
  background-color: rgba(20, 67, 87, 0.65);
}
.advance-layout #left-drawer,
.advance-layout #left-secondary-drawer {
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  overflow: hidden;
  z-index: 12;
}
.advance-layout #left-drawer > #toolbar,
.advance-layout #left-secondary-drawer > #toolbar {
  z-index: 9;
  background-color: #134459;
}
.advance-layout #left-drawer-modal {
  z-index: 14;
}
.advance-layout #left-secondary-drawer-modal {
  z-index: 13;
}
.advance-layout #left-drawer-modal,
.advance-layout #left-secondary-drawer-modal {
  color: #333;
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  border-radius: 0 14px 14px 0;
  overflow: hidden;
}
.advance-layout #left-drawer-modal > #toolbar,
.advance-layout #left-secondary-drawer-modal > #toolbar {
  z-index: 15;
  background-color: #134459;
}
.advance-layout .hover-menu {
  position: relative;
}
.advance-layout .hover-menu #left-drawer-modal,
.advance-layout .hover-menu #left-secondary-drawer-modal {
  /* hides modal */
  visibility: hidden;
  opacity: 0;
  transform: translateX(-1000px);
  transition: all 0.3s ease-out 0s, visibility 0s ease-out 0.5s;
}
.advance-layout .hover-menu:hover #left-drawer-modal,
.advance-layout .hover-menu:hover #left-secondary-drawer-modal {
  visibility: visible;
  opacity: 1;
  transform: translateX(0%);
  transition-delay: 0s, 0s;
  /* this removes the transition delay so the menu will be visible while the other styles transition */
}
.advance-layout #main-body {
  position: relative;
  z-index: 1;
}
.advance-layout #right-drawer {
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  overflow: hidden;
  z-index: 12;
  right: 0;
}
.advance-layout #right-drawer > #toolbar {
  z-index: 9;
  background-color: #134459;
}
.advance-layout #right-drawer-modal {
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  border-radius: 14px 0 0 14px;
  overflow: hidden;
  z-index: 14;
  right: 0;
}
.advance-layout #right-drawer-modal > #toolbar {
  z-index: 15;
  background-color: #134459;
}
.advance-layout #bottom-drawer {
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  overflow: hidden;
  z-index: 14;
  bottom: 0;
}
.advance-layout #bottom-drawer > #toolbar {
  z-index: 16;
  background-color: #134459;
}
.advance-layout #bottom-drawer-modal {
  position: absolute;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  border-radius: 14px 14px 0 0;
  overflow: hidden;
  z-index: 14;
  bottom: 0;
}
.advance-layout #bottom-drawer-modal > #toolbar {
  z-index: 15;
  background-color: #134459;
}
.advance-toolbar {
  position: relative;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: white;
  font-size: 15px;
  align-items: flex-end;
  /* All regions of the toolbar */
  /* all icons need to have this id to be valid css */
}
.advance-toolbar > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}
.advance-toolbar div#icons,
.advance-toolbar img#icons,
.advance-toolbar i#icons {
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
  line-height: inherit;
  cursor: pointer;
}
.advance-toolbar div#icons:hover.highlighted,
.advance-toolbar img#icons:hover.highlighted,
.advance-toolbar i#icons:hover.highlighted {
  color: gray !important;
  box-shadow: 0px -2px 0px 0px gray inset;
}
.advance-toolbar div#icons.selected,
.advance-toolbar img#icons.selected,
.advance-toolbar i#icons.selected {
  color: #4d90fe !important;
  box-shadow: 0px -2px 0px 0px #4d90fe inset;
}
.advance-toolbar i#icons.fa {
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
  line-height: inherit;
  cursor: pointer;
}
.advance-toolbar i#icons.fa:hover {
  color: gray !important;
  box-shadow: 0px -2px 0px 0px gray inset;
}
.advance-toolbar div#icons img {
  cursor: pointer;
  height: 65% !important;
}
/* all separators need to have this id to be valid css */
#separators {
  background-color: #E3F2FD;
  display: block;
  height: 60% !important;
  margin: 0px;
  width: 1px !important;
}
/* override */
.code-editor #separators,
.planogram-editor #separators,
.questionnaire #separators {
  height: 100% !important;
}
body {
  background-color: unset;
}
.y-flexbox-grid-item {
  height: 50px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #e0e0e0;
}
.y-flexbox-grid-item.table-cell {
  border-left: 1px solid #e0e0e0;
}
.y-flexbox-grid-item.left {
  justify-content: flex-start;
}
.y-flexbox-grid-item.block {
  display: block;
}
.y-flexbox-grid-item.no-border {
  border: none;
}
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
